import { useCallback, useMemo } from 'react';
import { isInBrowser } from '../../../common/utils/ssrUtils.js';

/**
 * Hook for logging Genesys-related messages
 * Controlled by localStorage 'genesysDebug' flag
 *
 * Enable logger by setting localStorage item:
 * localStorage.setItem('genesysDebug', 'true');
 */
export const useGenesysLogger = () => {
  const debug = useMemo(() => {
    if (!isInBrowser() || !window.localStorage) {
      return false;
    }
    return !!window.localStorage.getItem('genesysDebug');
  }, []);

  const log = useCallback(
    (...args: unknown[]) => {
      if (!debug) {
        return;
      }
      args.forEach(arg => {
        if (typeof arg === 'object' && arg !== null) {
          console.table(arg);
        } else {
          // eslint-disable-next-line no-console
          console.log(arg);
        }
      });
    },
    [debug]
  );

  return { log, debug };
};
